import React, { useEffect, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { useSearchParams } from 'react-router-dom'

import Dropdown from '@components/shared/form/Dropdown'

type SortItem = {
  name: string
  queryValue: string
}

interface Props {
  items: SortItem[]
  onSortChanged?: (order: string, newSearchParams: URLSearchParams) => void
}
const SortDropdown: React.FC<Props> = ({ items, onSortChanged }) => {
  const { t } = useTranslation()
  const [searchParams, setSearchParams] = useSearchParams()
  const [sortBy, setSortBy] = useState<string>('')

  const updateSort = (newValue: string): void => {
    setSortBy(newValue)

    const searchParams: URLSearchParams = new URLSearchParams(location.search)
    searchParams.set('order', newValue)
    if (typeof onSortChanged === 'function') {
      onSortChanged(newValue, searchParams)
    }

    setSearchParams(searchParams)
  }

  useEffect(() => {
    const order = searchParams.get('order')
    const newSort = items.find((item) => item.queryValue === order)
    setSortBy(newSort?.queryValue ?? items[0].queryValue)
  }, [searchParams, items])

  return (
    <Dropdown
      variant="sm"
      name="sort"
      borderless
      onChange={(e) => updateSort(e.target.value)}
      className="text-base"
      value={sortBy}>
      {items.map(({ name, queryValue }) => (
        <option key={name} value={queryValue}>
          {t(name)}
        </option>
      ))}
    </Dropdown>
  )
}

export default SortDropdown
